import { Location } from 'vue-router'


export const enum TableActionsTypes {
  copy = 'copy',
  download = 'download',
  add = 'add',
  edit = 'edit',
  view = 'view',
  delete = 'delete',
  logout = 'logout',
  history = 'history',
  sortable_positions_down = 'sortable-positions-down',
  sortable_positions_up = 'sortable-positions-up',
  su_as = 'su-as',
  upload = 'upload',
  update = 'update',
  positions_upload = 'positions_upload',
  decline = 'decline',
  accept = 'accept',
  open_new_tab = 'new-tab',
  enable = 'enable',
  finish = 'finish',
  admin = 'admin',
  generate = 'generate',
  convert = 'convert',
}

export interface TableAction<T = unknown> {
  action: TableActionsTypes;
  getHref?: (data: T) => string;
  getRoute?: (data: T) => Location;
  getFilter?: (data: T) => boolean;
  icon: string;
  target?: string;
  color?: string;
  tooltip: string;
}

export const COPY: TableAction = {
  action: TableActionsTypes.copy,
  icon: 'mdi-content-copy',
  tooltip: 'Скопировать',
}

export const DOWNLOAD: TableAction = {
  action: TableActionsTypes.download,
  icon: 'mdi-download',
  target: '_blank',
  tooltip: 'Скачать',
}

export const ADD: TableAction = {
  action: TableActionsTypes.add,
  icon: 'mdi-plus',
  tooltip: 'Добавить',
}

export const EDIT: TableAction = {
  action: TableActionsTypes.edit,
  icon: 'mdi-pencil',
  tooltip: 'Редактировать',
}

export const VIEW: TableAction = {
  action: TableActionsTypes.view,
  icon: 'mdi-eye-outline',
  tooltip: 'Посмотреть',
}

export const DELETE: TableAction = {
  action: TableActionsTypes.delete,
  icon: 'mdi-delete',
  color: 'error',
  tooltip: 'Удалить',
}

export const LOGOUT: TableAction = {
  action: TableActionsTypes.logout,
  icon: 'mdi-exit-to-app',
  tooltip: 'Выйти',
}

export const HISTORY: TableAction = {
  action: TableActionsTypes.history,
  icon: 'mdi-history',
  tooltip: 'История',
}

export const SORTABLE_POSITIONS_DOWN: TableAction = {
  action: TableActionsTypes.sortable_positions_down,
  icon: 'mdi-arrow-down',
  tooltip: 'Ниже',
}

export const SORTABLE_POSITIONS_UP: TableAction = {
  action: TableActionsTypes.sortable_positions_up,
  icon: 'mdi-arrow-up',
  tooltip: 'Выше',
}

export const SU_AS: TableAction = {
  action: TableActionsTypes.su_as,
  icon: 'mdi-login',
  tooltip: 'Авторизироваться за пользователя',
}

export const UPLOAD: TableAction = {
  action: TableActionsTypes.upload,
  icon: 'mdi-file-upload',
  tooltip: 'Отправить',
}

export const DECLINE: TableAction = {
  action: TableActionsTypes.decline,
  icon: 'mdi-close',
  color: 'error',
  tooltip: 'Отклонить',
}

export const ACCEPT: TableAction = {
  action: TableActionsTypes.accept,
  icon: 'mdi-check',
  color: 'success',
  tooltip: 'Принять',
}

export const OPEN_NEW_TAB: TableAction = {
  action: TableActionsTypes.open_new_tab,
  icon: 'mdi-link-variant',
  tooltip: 'Открыть в новой вкладке',
}


// helpers

export const createSuAs = <T extends { is_superuser?: boolean; username?: string }>(
  currentUserProfile: { username?: string; is_superuser?: boolean } | null,
): TableAction<T> => ({
  ...SU_AS,
  getFilter: (data: T) => {
    // Если пользователь не является суперюзером, показываем кнопку
    if (!data.is_superuser) {
      return true
    }

    // Если пользователь суперюзер, показываем кнопку только для default admin
    const defaultAdminUsername = process.env.VUE_APP_DEFAULT_ADMIN_USERNAME || 'admin'
    return currentUserProfile?.username === defaultAdminUsername
  },
})

export const createEdit = <T>(
  getRoute: TableAction<T>['getRoute'],
  getFilter?: TableAction<T>['getFilter'],
): TableAction<T> => ({
    ...EDIT,
    getRoute,
    getFilter,
  })

export const createView = <T>(
  getRoute: TableAction<T>['getRoute'],
  getFilter?: TableAction<T>['getFilter'],
): TableAction<T> => ({
    ...VIEW,
    getRoute,
    getFilter,
  })

export const createDownload = <T>(
  getHref: TableAction<T>['getHref'],
  getFilter?: TableAction<T>['getFilter'],
): TableAction<T> => ({
    ...DOWNLOAD,
    getHref,
    getFilter,
  })
